import { http_client } from '@/plugins/http_client';
const urlBase = 'api';
let urlSanciones = '/sanciones';

export const fetchExpediente = async id => {
  return await http_client(
    urlBase + urlSanciones + '/get-sancion-empleado/' + id,
    {},
    'GET'
  );
};

export default {
  fetchExpediente,
};
